import React from 'react';
import PropTypes from 'prop-types';

const BeeSVG = ({ className = 'w-10 h-10 animate-float' }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <ellipse cx="32" cy="32" rx="14" ry="12" fill="#FFB800" />
    <path
      d="M20 28h24M20 32h24M20 36h24"
      stroke="#000"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.2"
    />
    <path
      d="M20 24c-8-4-12 0-12 8"
      stroke="#FFD700"
      strokeWidth="3"
      strokeLinecap="round"
      opacity="0.5"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="-10 20 24;10 20 24;-10 20 24"
        dur="0.2s"
        repeatCount="indefinite"
      />
    </path>
    <path
      d="M44 24c8-4 12 0 12 8"
      stroke="#FFD700"
      strokeWidth="3"
      strokeLinecap="round"
      opacity="0.5"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        values="10 44 24;-10 44 24;10 44 24"
        dur="0.2s"
        repeatCount="indefinite"
      />
    </path>
    <circle cx="32" cy="22" r="5" fill="#704E00" />
    <path d="M29 18c-2-4-6-4-8-2" stroke="#704E00" strokeWidth="1.5" />
    <path d="M35 18c2-4 6-4 8-2" stroke="#704E00" strokeWidth="1.5" />
  </svg>
);

BeeSVG.propTypes = {
  className: PropTypes.string,
};

export default BeeSVG;
